import React, { Fragment, useState, useEffect } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { fetchData, postData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { Tabs, Tab, Box, Typography, Button, CircularProgress, Tooltip, TextField } from '@mui/material';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

export const CallReportCreate = (props) => {
    const { id } = useParams();
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);

    const { isAuthenticated, companyId, userId, logout, token } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
        }
    }, [isAuthenticated, companyId, token, logout]);

    const [data, setData] = useState([]);

    const [ServiceType, setServiceType] = useState("");
    const [Calltype, setCalltype] = useState("");
    const [ModalDescription, setModalDescription] = useState("");
    const [UnitSerialNo, setUnitSerialNo] = useState("");
    const [InstallationDate, setInstallationDate] = useState("");
    const [Distance, setDistance] = useState("");
    const [EngineerDiagnosis, setEngineerDiagnosis] = useState("");
    const [Observation, setObservation] = useState("");
    const [Action, setAction] = useState("");
    const [PendingReason, setPendingReason] = useState("");
    const [RemarksforASP, setRemarksforASP] = useState("");

    const [warranty, setwarranty] = useState("");
    const [ProductGroup, setProductGroup] = useState("");
    const [ProductCategory, setProductCategory] = useState("");

    useEffect(() => {
        fetchtableData();
    }, []);

    const fetchtableData = async () => {
        fetchData('RequestdetailsApi', `/RequestDetails/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setData(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching Customer Details:', error);
            });
    };

    const submitData = (event) => {
        event.preventDefault();
        setIsLoading(true);

        const payload = {
            CompanyId: companyId,
            CustomerId: data.customerID,
            VisitId: data.requestID,
            ServiceType: ServiceType,
            Calltype: Calltype,
            ModalDescription: ModalDescription,
            UnitSerialNo: UnitSerialNo,
            InstallationDate: InstallationDate,
            Distance: Distance,
            EngineerDiagnosis: EngineerDiagnosis,
            Observation: Observation,
            Action: Action,
            PendingReason: PendingReason,
            RemarksforASP: RemarksforASP,
            ProductCategory: ProductCategory,
            ProductGroup: ProductGroup,
            warranty: warranty
        };

        postData('BrotherPrintApi', payload, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    history.push('/CompanyPrint');
                }
            })
            .catch((error) => {
                console.error('Error submitting data:', error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const [tabIndex, setTabIndex] = useState(0);

    const handleTabChange = (event, newIndex) => {
        setTabIndex(newIndex);
    };

    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-2 mx-auto">
                <form onSubmit={submitData}>
                    <Box className="mb-4 flex items-center">
                        <div className='w-full mb-2 flex items-center'>
                            <h5>Field Report</h5>
                        </div>
                        <Tooltip title="Exit">
                            <Link to="/CompanyPrint">
                                <Button color="secondary">
                                    Exit <ExitToAppIcon />
                                </Button>
                            </Link>
                        </Tooltip>
                        <Tooltip title="SAVE">
                            <Button
                                onClick={submitData}
                                color="primary"
                                disabled={isLoading}
                            >
                                {isLoading ? (
                                    <CircularProgress size={24} color="inherit" />
                                ) : (
                                    'SAVE'
                                )}{' '}
                                <CheckCircleIcon />
                            </Button>
                        </Tooltip>
                    </Box>
                    <div className="w-full mb-4 flex">
                        <label className="block tracking-wide text-black text-base font-bold mb-2">
                            Customer: <strong style={{ color: 'blueviolet' }}>{data.customer}</strong>
                        </label>
                    </div>
                    <Tabs value={tabIndex} onChange={handleTabChange}>
                        <Tab label="Service Details" />
                        <Tab label="Engineer Report" />
                    </Tabs>

                    <TabPanel value={tabIndex} index={0}>
                        <Box className="mb-4 grid grid-cols-2 gap-4">

                            <div className="w-1/2 mr-2">
                                <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="name">
                                    Service Type
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={ServiceType}
                                    onChange={(e) => setServiceType(e.target.value)}
                                    type="text"
                                    placeholder="Enter Service Type"
                                />
                            </div>
                            <TextField
                                label="Call Type"
                                value={Calltype}
                                onChange={(e) => setCalltype(e.target.value)}
                                fullWidth
                            />
                            <TextField
                                label="Unit Serial No"
                                value={UnitSerialNo}
                                onChange={(e) => setUnitSerialNo(e.target.value)}
                                fullWidth
                            />
                            <TextField
                                label="Installation Date"
                                type="date"
                                value={InstallationDate}
                                onChange={(e) => setInstallationDate(e.target.value)}
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                            />
                            <TextField
                                label="Distance"
                                value={Distance}
                                onChange={(e) => setDistance(e.target.value)}
                                fullWidth
                            />
                        </Box>
                        <div className="w-full mb-4">
                            <TextField
                                label="Modal Description"
                                value={ModalDescription}
                                onChange={(e) => setModalDescription(e.target.value)}
                                fullWidth
                                multiline
                                rows={3}
                            />
                        </div>
                    </TabPanel>

                    <TabPanel value={tabIndex} index={1}>
                        <Box className="mb-4 grid grid-cols-2 gap-4">
                            <div className="w-full mb-4">
                                <TextField
                                    label="Engineer Diagnosis"
                                    value={EngineerDiagnosis}
                                    onChange={(e) => setEngineerDiagnosis(e.target.value)}
                                    fullWidth
                                    multiline
                                    rows={2}
                                />
                            </div>
                            <div className="w-full mb-4">
                                <TextField
                                    label="Observation"
                                    value={Observation}
                                    onChange={(e) => setObservation(e.target.value)}
                                    fullWidth
                                    multiline
                                    rows={2}
                                />
                            </div>
                            <div className="w-full mb-4">
                                <TextField
                                    label="Action"
                                    value={Action}
                                    onChange={(e) => setAction(e.target.value)}
                                    fullWidth
                                    multiline
                                    rows={2}
                                />
                            </div>
                            <div className="w-full mb-4">
                                <TextField
                                    label="Pending Reason"
                                    value={PendingReason}
                                    onChange={(e) => setPendingReason(e.target.value)}
                                    fullWidth
                                    multiline
                                    rows={2}
                                />
                            </div>
                            <div className="w-full mb-4">
                                <TextField
                                    label="Remarks for ASP"
                                    value={RemarksforASP}
                                    onChange={(e) => setRemarksforASP(e.target.value)}
                                    fullWidth
                                    multiline
                                    rows={2}
                                />
                            </div>
                            <div className="w-full mb-4">
                                <TextField
                                    label="Warranty"
                                    value={warranty}
                                    onChange={(e) => setwarranty(e.target.value)}
                                    fullWidth
                                />
                            </div>
                            <div className="w-full mb-4">
                                <TextField
                                    label="Product Group"
                                    value={ProductGroup}
                                    onChange={(e) => setProductGroup(e.target.value)}
                                    fullWidth
                                />
                            </div>
                            <div className="w-full mb-4">
                                <TextField
                                    label="Product Category"
                                    value={ProductCategory}
                                    onChange={(e) => setProductCategory(e.target.value)}
                                    fullWidth
                                />
                            </div>
                        </Box>
                    </TabPanel>
                </form>
            </div>
        </Fragment>
    );
};

const TabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`tabpanel-${index}`}
            aria-labelledby={`tab-${index}`}
            {...other}
        >
            {value === index && <Box p={3}>{children}</Box>}
        </div>
    );
};
